// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> aion-management-comfy -> orchard-park
// Generated: 2026-10-22T20:06:22.713Z
// Counts: 5 design, 68 content, 61 slot group, 2 collection binding, 9 section, 5 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Accessibility",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Amenities",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Apply Now",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Floor Plans",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Gallery",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 48px;\">Welcome To</span></h1><h1><span style=\"font-size: 48px;\"><span data-type=\"field-token\" data-field=\"property_name\"></span></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Interactive Map",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Neighborhood",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>The heart of a growing community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Privacy Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace a Life of Connection in Your New Apartment Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Schedule a Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Virtual Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Transparent pricing for <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Fee Information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Your pet belongs <em>here, too.</em></h3><h3></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Orchard Park Apartments in Edgewater Park, NJ, offering spacious one- and two-bedroom floor plans in a convenient Burlington County location. Our community is minutes from Routes 130, I‑295, and public transit, making commutes to Philadelphia, Camden, and Trenton simple. Enjoy nearby shopping, dining, and outdoor recreation at local parks and nature centers.</p><p>Each apartment features wall‑to‑wall carpeting, oversized closets, private patios or balconies, and modern comforts like heating, air conditioning, and cable-ready access. Our pet-friendly apartments in Edgewater Park welcomes your furry friends. Relax by the sparkling pool, use our on-site laundry centers and free parking, simplify your life at Orchard Park Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.heading": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-form.talk_blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The amenities at Orchard Park provide a living experience that elevates your every day and makes you glad to come home. From fully equipped kitchens and private patios or balconies to playgrounds and ample parking, Orchard Park is the perfect place to call home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Orchard Park in Beverly, NJ, where stylish floor plans meet modern amenities! Choose from our one-bedroom, two-bedroom, or cozy studio options. Enjoy perks like resident activities, EV charging stations, and a refreshing swimming pool. Ready to elevate your lifestyle? Lease online today and find your new home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our suburban New Jersey community with upgraded interiors is located in a serene, park-like setting. From beautifully manicured lawns to neutral interior tones that serve as the perfect backdrop for your personal decorative style, everything you need to feel comfortable at home is right here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture yourself here. Check out snapshots of our pet-friendly community, comfortable apartments, and our plentiful community amenity offerings. Enjoy warm weather at the swimming pool or playground, or prepare a cozy lunch indoors for the colder days with your fully equipped kitchen. Contact our friendly leasing staff today and discover more reasons why our residents love living here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.name": {
    "overrideType": "VALUE",
    "customValue": "Orchard Park Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Orchard Park in Beverly, NJ, where comfort meets convenience! Choose from our stylish one-bedroom, two-bedroom, or studio floor plans, and enjoy amenities like a sparkling swimming pool, resident activities, and pet-friendly spaces. Use our interactive community map to find your perfect home today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Conveniently situated near top employers, shopping centers, and a host of recreation spots, Orchard Park boasts a location that is perfect for any suburban dweller who values convenience. Our apartments in Edgewater Park are nestled in a suburban setting in Burlington County that provides the haven you desire while giving you access to the urban conveniences that make daily living effortless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Orchard Park in Beverly, NJ, where your perfect home awaits! Choose from our stylish studio, one-bedroom, or two-bedroom floor plans tailored for your lifestyle. Stay connected—access our resident portal to pay rent, schedule maintenance, and enjoy seamless living today! Your community is just a click away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "Download the Loft Resident Mobile App",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>At Orchard Park in Beverly, NJ, choose from thoughtfully designed studio, one-bedroom, and two-bedroom floor plans that perfectly suit your lifestyle. Experience the charm of our community firsthand—schedule a tour today and hear what our residents love about calling Orchard Park home!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Thank You",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>Thank you for reaching out to Orchard Park in beautiful Beverly, NJ! With thoughtfully designed studio, one, and two-bedroom floor plans, your ideal home awaits. Keep an eye on your inbox—our friendly team will connect soon to help you start this exciting journey!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Orchard Park in Beverly, NJ, our diverse floor plans—ranging from stylish studios to spacious two bedrooms—cater to every lifestyle. Immerse yourself in our vibrant community by taking a virtual tour today, and envision your perfect home nestled among nature's beauty. Experience life at Orchard Park like never before!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "residentaccess.login_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Access Resident Portal Login"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-63c6-7679-bb70-dc4fcca0c66c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Communal laundry room with rows of front-loading washing machines along the wall."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0268-6d41-774e-b8e4-ebd238543588.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Row of white front-loading washers and dryers in a communal laundry room."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0268-8597-72a9-8983-12c2de43a1ff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Row of dark blue parcel lockers against a stone wall at an apartment community."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166333/019d0268-8597-72a9-8983-12c2de43a1ff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Amazon Hub package lockers with \"hub\" logo, located outdoors next to a stone wall."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d026a-2e46-72a8-bb3e-c97767775cf9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with a beige sofa, glass coffee table, TV, and sliding balcony door."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d026a-3128-74fd-b539-c1a7980c8373.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment kitchen with light wood cabinets, white appliances, and a small dining table by the window."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d026a-3a05-745f-b1d4-65c42c8d7595.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "White kitchen in an apartment with black appliances, grey countertops, and a small breakfast bar with two stools."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-6e26-779e-aade-f73840c43635.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Brick apartment building exterior with a small covered entry and green lawn."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0268-5133-704c-b397-8648d4d95917.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of Orchard Park apartment community at dusk, brick building with signage and a parking lot."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-2989-775b-b096-772e863f967d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Brick apartment building with landscaped entrances and colorful flowers."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d026a-4066-74e0-93b9-4a77f3c7e263.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Balcony of an apartment with a small round table and chairs overlooking a grassy courtyard and parking."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-35b5-71fd-928c-fe842c949102.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community pool with lounge chairs and surrounding apartment buildings."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0269-4472-716c-8318-8f61a46ca86e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor playground with green slides and a climbing structure on a dark gravel surface, surrounded by trees."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0268-632d-7469-92a7-d270e618c176.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor barbecue scene with people grilling; a hand holds a plate of mushrooms and bread."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.certificate": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Certificate of Occupancy"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.custom_optional": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Yearly Pool Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50–$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$300"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "25"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab03-5fb6-701e-a329-aaa7b2d8d5ff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of brick apartment buildings with green lawns and a sidewalk."
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0268-2bed-737d-9afd-0272fae4a463.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in a modern apartment with beige sofas, a coffee table, wall TV, and abstract art."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d0268-4ede-74ed-8511-628d5e434650.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a resort-style outdoor pool with lounge chairs at an apartment community."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d026a-2e46-72a8-bb3e-c97767775cf9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with a beige sofa, glass coffee table, TV, and sliding balcony door."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019d026a-3128-74fd-b539-c1a7980c8373.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment kitchen with light wood cabinets, white appliances, and a small dining table by the window."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Friend Coffee Shop "
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Coffee & Cafe"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Cafe serving Turkish-inspired coffee and eats with a friendly atmosphere and flavorful dishes."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Target"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections."
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-0875-778d-929e-f1612141ea24.webp"
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Mill Creek Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Recreation"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "This 14-acre park offers nature trails, playgrounds, a pavilion & picnic tables."
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-9296-751e-bf93-286019cd266d.webp"
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Cinnaminson Diner"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Diner & Brunch"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Family-run diner offering a large menu for breakfast, lunch, and dinner, plus ice cream, cakes and pizza."
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-b59c-76cf-b09f-92d4241cab33.webp"
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Walt Whitman House"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Famed poet Walt Whitman’s preserved former home where he died, open to the public for tours."
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-4e99-72f8-b2a6-b1bf3368ab1f.webp"
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Amico Island Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Recreation & Trails"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A 55-acre peninsula of forest, meadow & wetlands offering hiking, biking, fishing & picnicking."
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-9fd8-72db-a623-1f3bb9c895a8.webp"
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Curran's Irish Inn"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Nightlife"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Local watering hole with regular special events like trivia nights & band performances."
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-d20d-763b-bc07-5dd20768d38f.webp"
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Freedom Mortgage Pavilion"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music & Entertainment"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Large outdoor performing arts amphitheater transforms into a smaller, enclosed venue for the winter."
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-6d41-70ba-bfba-e0ca0e925d02.webp"
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Bella Rosa (previously Zio's Tuscan Grille)"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Italian Dining"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Laid-back Italian option with booths whipping up brick-oven pies, panini & traditional entrees."
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-d593-77ef-82ff-3855bcce3e95.webp"
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Double Nickel Brewing Company"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Brewery & Taproom"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Local craft brewery pouring house-made beers in a welcoming taproom, a laid-back spot for an evening out."
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-dc26-77f3-936c-24b981953b68.webp"
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Regal Moorestown Mall"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema & Theater"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Theater complex with multiple screens featuring new release films, plush seating & concession stand."
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd927-52ec-75c5-a6d0-166b85bdaf4f.webp"
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Bagelati"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dessert & Late-Night Bites"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Bagel shop offering sandwiches, plus breakfast items, ice cream, coffee, and smoothies."
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd926-f95f-763a-8e4d-1aabbbd0fff8.webp"
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab03-3a02-73b3-a0d1-f3bf3fd94232.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a bed, dresser, and closet."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/01a0ab03-52ec-76ed-a646-2ad9d2a32a5b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, black appliances, and a small dining area with a glass table."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166333/019fd928-628f-76bc-b635-5d0876878bca.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Children's playground with slides and climbing structures."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "homegallerypreview.photos": {
    "limit": 4,
    "hiddenIds": null,
    "orderedIds": [
      "custom_b896e2a0-7e23-4177-970a-077a1484557b",
      "custom_17b6cd2e-3167-4213-a3c2-cdb9803ce45e",
      "custom_b875ac25-19a3-482a-875d-da064e36ca06",
      "custom_2db12211-3485-42cb-948f-73e34c705dd3",
      "custom_7cdb57d6-8e07-4f2b-9f13-51c1b6e79a8d",
      "custom_792b4ef4-5da1-40f3-a032-136092ac9590",
      "custom_cb2058c1-acf6-49c6-8e84-e742e86959ce",
      "custom_2f58b842-5420-4617-8451-18b0239e8408",
      "custom_e76872a0-9c47-486a-be32-eb200346cee9",
      "custom_6fa23f62-36dc-457d-bca5-cd153760a41b",
      "custom_31a498fe-636e-4bc2-b778-e440e2b61448",
      "custom_153e3cf8-2dad-4ece-acaa-4f07ca998bef",
      "custom_114c1210-d66d-4925-b073-0630f52c8f3b",
      "custom_27d2923c-be79-462a-b0e3-ba4f516760b2",
      "custom_0cacb846-a633-4b9b-a0ad-4cf326caa559",
      "custom_6fa293f5-1b7a-41d5-a981-2e5399953178",
      "custom_2117c039-a71e-46e2-a16f-7523089a781e",
      "custom_658886a3-cdac-4622-8e16-1769bf07dc29",
      "custom_5994e4de-5b6a-4bb8-b166-005c0b6c97eb",
      "custom_7f5557b0-28b6-400c-87f6-6bf40aba8763",
      "custom_66bcc5c1-966b-403a-a557-da7d5d646a78",
      "custom_8e46342b-a35d-49e7-b3a0-4a07b6d0b461",
      "custom_fec3ed71-b368-42c8-aaac-122e5b26b26f",
      "custom_bd416a91-fb42-48cb-a1ac-11b13cb0490e",
      "custom_e3e47972-56e7-4641-a8bd-662fc4550ecd",
      "custom_96705bbe-15de-4f81-bcd3-ce80cdec92c3",
      "custom_543bff03-abe7-49f4-b0a7-16d1ccc6e812",
      "custom_4bc7f82d-a695-422a-824f-4fa9d59d1865",
      "custom_2daa0118-c329-4309-89a1-fa16f9045ad5",
      "custom_3baeb389-4a97-4e6a-9623-afe1bc4485b4",
      "custom_41c21e34-bbd3-423e-afee-47e70e8d15df"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_6fa23f62-36dc-457d-bca5-cd153760a41b"
    ],
    "orderedIds": [
      "custom_fec3ed71-b368-42c8-aaac-122e5b26b26f",
      "custom_8e46342b-a35d-49e7-b3a0-4a07b6d0b461",
      "custom_b896e2a0-7e23-4177-970a-077a1484557b",
      "custom_6fa293f5-1b7a-41d5-a981-2e5399953178",
      "custom_5994e4de-5b6a-4bb8-b166-005c0b6c97eb",
      "custom_66bcc5c1-966b-403a-a557-da7d5d646a78",
      "custom_e3e47972-56e7-4641-a8bd-662fc4550ecd",
      "custom_b875ac25-19a3-482a-875d-da064e36ca06",
      "custom_3baeb389-4a97-4e6a-9623-afe1bc4485b4",
      "custom_543bff03-abe7-49f4-b0a7-16d1ccc6e812",
      "custom_7f5557b0-28b6-400c-87f6-6bf40aba8763",
      "custom_2117c039-a71e-46e2-a16f-7523089a781e",
      "custom_7cdb57d6-8e07-4f2b-9f13-51c1b6e79a8d",
      "custom_792b4ef4-5da1-40f3-a032-136092ac9590",
      "custom_2f58b842-5420-4617-8451-18b0239e8408",
      "custom_cb2058c1-acf6-49c6-8e84-e742e86959ce",
      "custom_e76872a0-9c47-486a-be32-eb200346cee9",
      "custom_6fa23f62-36dc-457d-bca5-cd153760a41b",
      "custom_31a498fe-636e-4bc2-b778-e440e2b61448",
      "custom_2db12211-3485-42cb-948f-73e34c705dd3",
      "custom_17b6cd2e-3167-4213-a3c2-cdb9803ce45e",
      "custom_114c1210-d66d-4925-b073-0630f52c8f3b",
      "custom_96705bbe-15de-4f81-bcd3-ce80cdec92c3",
      "custom_27d2923c-be79-462a-b0e3-ba4f516760b2",
      "custom_658886a3-cdac-4622-8e16-1769bf07dc29",
      "custom_2daa0118-c329-4309-89a1-fa16f9045ad5",
      "custom_4bc7f82d-a695-422a-824f-4fa9d59d1865",
      "custom_0cacb846-a633-4b9b-a0ad-4cf326caa559",
      "custom_41c21e34-bbd3-423e-afee-47e70e8d15df",
      "custom_2923cff3-ab9f-4e2a-8e39-2fc1ecaa8ba0",
      "custom_153e3cf8-2dad-4ece-acaa-4f07ca998bef"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingBottom": "30px"
    }
  },
  "hero.name": {
    "properties": {
      "paddingBottom": "50px"
    }
  },
  "propertyoverview.blurb": {
    "properties": {
      "fontWeight": "300"
    }
  },
  "residentaccess.app_heading": {
    "properties": {
      "fontWeight": "700"
    }
  }
};
